import { PUBLIC_BASE_URL_ENV, PUBLIC_CHANNEL } from 'tools/environments';

import { Icon } from 'core/generic/elements/icons';

import styles from './simple-header.module.scss';

const ClubText: { [key: string]: string } = {
	mancity: 'Manchester City FC',
	palermo: 'Palermo FC',
	newyork: 'New York City FC',
};

export const SimpleHeader = () => {
	const theme = PUBLIC_CHANNEL || 'mancity';
	const logoUrl = `/images/${theme}/crest.svg`;

	const handleGoBack = () => {
		window.history.back();
	};

	return (
		<div className={styles['header-navigation']}>
			<div
				className={`container ${styles['container']} ${styles['center']}`}
			>
				<button
					onClick={handleGoBack}
					rel="noopener noreferrer"
					className={styles.back}
					aria-label="back button"
				>
					<Icon variant="ChevronLeft" className={styles.icon} />
				</button>
				<a
					href={PUBLIC_BASE_URL_ENV}
					className={styles.crest}
					aria-label={ClubText[theme]}
				>
					<img src={logoUrl} alt={ClubText[theme]} />
				</a>
			</div>
		</div>
	);
};

export default SimpleHeader;
